import { render, staticRenderFns } from "./PaymentFlags.vue?vue&type=template&id=1795e1ac&scoped=true&"
import script from "./PaymentFlags.vue?vue&type=script&lang=js&"
export * from "./PaymentFlags.vue?vue&type=script&lang=js&"
import style0 from "./PaymentFlags.vue?vue&type=style&index=0&id=1795e1ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1795e1ac",
  null
  
)

export default component.exports